// extracted by mini-css-extract-plugin
export default {"root":"LXCards_root__wyDU+","readonly":"LXCards_readonly__zOF50"};